export default "__VITE_ASSET__CPOAp77V__"